const resetPasswordModals = document.querySelectorAll(".reset-modal");
const unShowLoginModals = document.querySelectorAll(".login-modal");
const resetPasswordButtons = document.querySelectorAll(".reset-button");
const cancelReset = document.querySelector(".cancel-reset");
const signUpButtons = document.querySelectorAll(".sign-up-button");
const registerForms = document.querySelectorAll(".register-form");
const loginForms = document.querySelectorAll(".login-form");
const loginButtons = document.querySelectorAll(".login__btn");

const showResetPasswordModal = () => {
    resetPasswordModals.forEach(modal => {
        modal.style.display = 'block';
    })
    unShowLoginModals.forEach(item => item.classList.add('active'));
}

const hideResetPasswordModal = () => {
    resetPasswordModals.forEach(modal => {
        modal.style.display = 'none';
    })
    unShowLoginModals.forEach(item => item.classList.remove('active'));
}

const showRegisterModal = () => {
    loginForms.forEach(form => {
        form.classList.toggle('display-desktop');
    });
    registerForms.forEach(form => {
        form.classList.toggle('display-desktop');
    });
}

const modalListener = () => {
    resetPasswordButtons?.forEach(button => {
        button?.addEventListener("click", showResetPasswordModal);
    })
    cancelReset?.addEventListener("click", hideResetPasswordModal);
    signUpButtons?.forEach(button => {
        button?.addEventListener("click", showRegisterModal);
    });
    loginButtons?.forEach(button => {
        button?.addEventListener("click", showRegisterModal);
    })
}

export default modalListener;